const bankTransformer = response => {
  return response.map(e => ({ key: e.key, label: e.title, value: e.title, id: e.id }))
}

export default bankTransformer
